module.exports = __webpack_public_path__ + "static/media/home14.3f580361.jpg";